import { Divider, IconButton, OverflowingTypography, Stack, Tag, tagClasses, } from "../components";
import { CloseOutline, ShapeIcon } from "../icons";
import React from "react";
export const TableFilterChip = ({ column, condition, value, onRemoveClick, isRemoveDisabled = false, styles, }) => (React.createElement(Stack, { flexDirection: "row", alignItems: "center" },
    React.createElement(Tag, { variant: "outlined", density: "dense", rounded: true, startNode: onRemoveClick ? (React.createElement(IconButton, { variant: "ghost", density: "none", onClick: onRemoveClick, disabled: isRemoveDisabled, disableActiveEffect: true, disableHoverEffect: true, disableFocusEffect: true },
            React.createElement(CloseOutline, { size: "xs" }))) : undefined, sx: {
            [`&.${tagClasses.outlined}`]: {
                borderLeft: 1,
                borderTop: 1,
                borderBottom: 1,
                borderColor: (theme) => theme.palette.outline,
                borderRadius: 0,
                borderTopLeftRadius: (theme) => theme.radius.full,
                borderBottomLeftRadius: (theme) => theme.radius.full,
                boxShadow: "none",
            },
        } },
        React.createElement(Stack, { flexDirection: "row", alignItems: "center", gap: 2 },
            styles && (React.createElement(ShapeIcon, { oval: true, fill: styles.fill || undefined, stroke: styles.stroke || undefined })),
            React.createElement(OverflowingTypography, { variant: "body3", fontWeight: "semibold", sx: {
                    maxWidth: (theme) => theme.spacing(14),
                    minWidth: (theme) => theme.spacing(14),
                } }, column))),
    React.createElement(Divider, { orientation: "vertical", color: 200, sx: {
            margin: 0,
        } }),
    React.createElement(Tag, { variant: "outlined", density: "dense", rounded: true, sx: {
            [`&.${tagClasses.outlined}`]: {
                borderRight: 1,
                borderTop: 1,
                borderBottom: 1,
                borderColor: (theme) => theme.palette.outline,
                borderRadius: 0,
                borderTopRightRadius: (theme) => theme.radius.full,
                borderBottomRightRadius: (theme) => theme.radius.full,
                boxShadow: "none",
            },
        } },
        React.createElement(OverflowingTypography, { variant: "body3", fontWeight: "semibold", sx: {
                maxWidth: (theme) => theme.spacing(18),
                minWidth: (theme) => theme.spacing(18),
            } }, value ? `${condition}: ${value}` : condition))));
//# sourceMappingURL=TableFilterChip.js.map